// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.required-marker {
  top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_shared/U2000_components/U2000_creditcardtoken/U2000_moneristoken/U2000_moneristoken.component.scss"],"names":[],"mappings":"AAIA;EACI,SAAA;AAHJ","sourcesContent":["\n@import \"../../../../U2000_style/U2000_style-mixins\";\n@import \"../../../../U2000_style/U2000_style-variables\";\n\n.required-marker {\n    top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
